module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp23_8023.5d658a1d.png";